/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]];
const ArrowBigLeft = createLucideIcon("arrow-big-left", __iconNode);

export { __iconNode, ArrowBigLeft as default };
//# sourceMappingURL=arrow-big-left.js.map
